import React from "react";
import { useSelector } from "react-redux";

import {
  Grid,
  makeStyles,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { unconnectedTenantsData } from "./sample";
import { Box } from "../../pages/dashboard/buildingInfo/Box";
import RemoveIcon from "../../assets/images/icons/remove.svg";
import { GroupButton } from "../../pages/dashboard/buildingInfo/GroupButton";
import { Icon, StyledTableRow, StyledTableCell } from "../base";
import { nFormatter, currencyFormatter, capitalize } from "../../services";

const useStyles = makeStyles((theme) => ({
  unconnectedPercentage: {
    color: COLORS.red,
  },
  caption: {
    fontWeight: 700,
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    borderRadius: 8,
    maxHeight: 529,
    border: `1px solid ${COLORS.darks[0][10]}`,
    boxShadow: "none",
  },
  nameCell: {
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
  },
}));

export const ConnectTenants = ({ onClose }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = useSelector((state) => state.auth.currency.symbol);

  return (
    <Box maxWidth="md" width={700}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h2">Connect Unconnected Tenants (16)</Typography>
        <Icon src={RemoveIcon} hoverable onClick={onClose} />
      </Grid>

      <TableContainer className={classes.tableContainer}>
        <Table aria-label="simple-table">
          <TableHead>
            <StyledTableRow style={{ borderBottom: `1px solid ${COLORS.darks[0][10]}` }}>
              <StyledTableCell>
                <Typography variant="body1" className={classes.caption}>
                  Location
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="body1" className={classes.caption}>
                  Consumer name
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="body1" className={classes.caption}>
                  {capitalize(user?.unit_system)}
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="body1" className={classes.caption} noWrap>
                  Est, Unrealized Rev/Y
                </Typography>
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {unconnectedTenantsData.map((row, i) => (
              <React.Fragment key={i}>
                <StyledTableRow style={{ backgroundColor: COLORS.white }}>
                  <StyledTableCell
                    rowSpan={unconnectedTenantsData[i].tenants.length + 1}
                    style={{
                      borderRight: `1px solid ${COLORS.darks[0][25]}`,
                      verticalAlign: "top",
                    }}
                  >
                    <Typography variant="body1">{row.building_name}</Typography>
                    <Typography variant="body1">{row.address}</Typography>
                    <Typography className={classes.unconnectedPercentage} variant="body1">
                      ({row.percentage}% unconnected)
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
                {row.tenants.map((tenant, j) => (
                  <StyledTableRow key={j + 100}>
                    <StyledTableCell style={{ padding: "8px 20px" }}>
                      <Grid>
                        <Typography variant="body1">{tenant.name}</Typography>
                        <Typography variant="body1">{tenant.email}</Typography>
                      </Grid>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography variant="body1">
                        {nFormatter(tenant[user?.unit_system])}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography variant="body1">
                        {currencyFormatter(tenant.unrealized_revenue, currencySymbol)}
                      </Typography>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <GroupButton
        buttons={[
          { text: "SHARE LIST" },
          { text: "EXPORT" },
          {
            text: "CANCEL",
            onClick: onClose,
          },
        ]}
      />
    </Box>
  );
};
